module.exports = __webpack_public_path__ + "img/sack_left.d1fd24db.jpg";